<div class="row text-center">
	<div class="col step">{{'STEP' | translate}} {{stepIndex}} {{'STEP_OF' | translate}} {{stepTotal}}</div>
</div>
<div class="row">
	<div class="col start-info">
		<div class="row align-items-start">
			<div class="col-1">
				<fa-icon [icon]="faQuestionCircle"></fa-icon>
			</div>
			<div class="col-10">
				<p class="title">{{title}}</p>
				<span class="subtext">{{subtext}}</span>
			</div>
		</div>
	</div>
</div>